import { CostDetailsHeader } from './components/costDetailsHeader';

export const CostDetails = () => {
  return <CostDetailsHeader />;
};
